import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import { CDN_URL } from "@/consts";
import { useStrings } from "@/lib/i18n/context";

const STEP_IMAGES = [
  `${CDN_URL}/landing/steps/step1.png`,
  `${CDN_URL}/landing/steps/step2.png`,
  `${CDN_URL}/landing/steps/step3.png`,
];

const StepsSection = () => {
  const s = useStrings();
  const steps = s.steps.items.map((step, index) => ({ ...step, image: STEP_IMAGES[index] }));
  return (
    <BasicBlock
      header={s.steps.header}
      mobileHeader={s.steps.mobileHeader}
      subHeader={s.steps.subHeader}
      customCTA={{ text: s.cta.makeAccount, href: "https://crayo.ai/signup" }}
    >
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {steps.map((step, index) => (
          <div key={index} className={`flex w-full flex-col rounded-xl border border-[#D7DBEA]`}>
            <Image
              src={step.image}
              alt={step.title}
              width={782}
              height={476}
              draggable={false}
              className="w-full rounded-t-xl"
            />
            <div className="flex select-none flex-col items-start justify-center gap-2 px-4 py-6">
              <h2 className="flex items-center gap-2 text-xl">
                <span className="flex min-h-[2em] min-w-[2em] items-center justify-center rounded-full bg-[#335CFF] text-xs text-white">
                  {index + 1}
                </span>{" "}
                {step.title}
              </h2>
              <p className="text-base text-[#616885]">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </BasicBlock>
  );
};

export default StepsSection;
